/**
 * Lectures Angles Cell - Frontend
 * @description Cell component for displaying inclination angles in LecturesTable
 */

import React from 'react';
import { CellContext } from '@tanstack/react-table';
import { LecturesTableData } from '@/types/operational-ui.types';

interface LecturesSingleAnglesCellProps {
  info: CellContext<LecturesTableData, number>;
}

export const LecturesSingleAnglesCell: React.FC<LecturesSingleAnglesCellProps> = ({ info }) => {
  const value = info.getValue();
  // const row = info.row.original;

  return (
    <div className="text-sm text-center">
      <div className="font-medium text-gray-900">{value.toFixed(2)}</div>
    </div>
  );
};
